import AmbassadorShell, { card, eyebrow, h1Style, muted, primaryBtn, Reveal } from "./_AmbassadorShell";
import { Link } from "react-router-dom";

// Payouts tooling lives in the shared ElectricSheep operator console.
export default function AmbassadorPayouts() {
  return (
    <AmbassadorShell>
      <Reveal>
        <p style={eyebrow}>Payouts · cutover in progress</p>
        <h1 style={h1Style}>Payout runs moved.</h1>
        <div style={{ ...card, marginTop: 16 }}>
          <p style={{ color: muted, fontSize: 16, margin: 0 }}>
            The payout preview and approve/run actions are now run from the
            shared ElectricSheep operator console. Ping{" "}
            <strong>admin@electricsheephq.com</strong> for access.
          </p>
          <div style={{ marginTop: 16 }}>
            <Link to="/ambassadors/dashboard" style={primaryBtn}>Back to dashboard →</Link>
          </div>
        </div>
      </Reveal>
    </AmbassadorShell>
  );
}